import { EntryFields } from 'contentful';

/**
 * Converts a plain string to a Contentful RichText Document structure
 * @param text - The plain text string to convert
 * @returns A RichText Document with the text in a paragraph
 */
export function stringToRichTextDocument(text: string): EntryFields.RichText {
  return {
    nodeType: 'document',
    data: {},
    content: [
      {
        nodeType: 'paragraph',
        data: {},
        content: [
          {
            nodeType: 'text',
            value: text,
            marks: [],
            data: {},
          },
        ],
      },
    ],
  } as unknown as EntryFields.RichText;
}
